// RB-MY01-PalmGarden.web/src/components/CustomGrid.tsx
import React from 'react';
import { Grid, GridProps } from '@mui/material';

interface CustomGridItemProps extends Omit<GridProps, 'item'> {
  item?: boolean;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export const GridItem: React.FC<CustomGridItemProps> = ({ children, ...props }) => {
  return (
    <Grid component="div" item {...props}>
      {children}
    </Grid>
  );
};

export const GridContainer: React.FC<GridProps> = ({ children, ...props }) => {
  return (
    <Grid container {...props}>
      {children}
    </Grid>
  );
}; 